(function() {
    'use strict';

    const TRACKING_API_URL = window.TRACKING_API_URL || '/shopify/pprice/api/tracking.php';
    const SESSION_ID_KEY = 'tracking_session_id';
    const trackingProduct = window.trackingProduct || null;

    // Get or create session ID
    function getSessionId() {
        let sessionId = sessionStorage.getItem(SESSION_ID_KEY);
        if (!sessionId) {
            sessionId = 'sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            sessionStorage.setItem(SESSION_ID_KEY, sessionId);
        }
        return sessionId;
    }

    // Track event
    function trackEvent(eventType, data = {}) {
        const payload = {
            event_type: eventType,
            url: window.location.href,
            referrer: document.referrer || null,
            screen_width: window.screen.width,
            screen_height: window.screen.height,
            language: navigator.language || navigator.userLanguage,
            timezone: Intl.DateTimeFormat ? Intl.DateTimeFormat().resolvedOptions().timeZone : null,
            session_id: getSessionId(),
            ...data
        };

        // Use fetch with keepalive for better reliability
        // Note: We use 'omit' to avoid CORS credentials issues
        // If backend requires credentials, change to 'include' and ensure backend sets Access-Control-Allow-Credentials: true
        fetch(TRACKING_API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            keepalive: true,
            mode: 'cors',
            credentials: 'omit' // Omit credentials to avoid CORS issues
        }).catch(() => {
            // Silently fail - tracking should not break the page
        });
    }

    // Check if product is out of stock
    function checkOutOfStock() {
        if (!trackingProduct) return;

        // Check all variants for out of stock
        trackingProduct.variants.forEach(variant => {
            if (!variant.available || variant.inventory_quantity <= 0) {
                trackEvent('out_of_stock', {
                    product_id: trackingProduct.id,
                    product_title: trackingProduct.title,
                    variant_id: variant.id
                });
            }
        });

        // Also listen for variant changes
        const variantInput = document.querySelector('input[name="id"], select[name="id"]');
        if (variantInput) {
            variantInput.addEventListener('change', function() {
                const selectedVariantId = parseInt(this.value);
                const variant = trackingProduct.variants.find(v => v.id === selectedVariantId);
                
                if (variant && (!variant.available || variant.inventory_quantity <= 0)) {
                    trackEvent('out_of_stock', {
                        product_id: trackingProduct.id,
                        product_title: trackingProduct.title,
                        variant_id: variant.id
                    });
                }
            });
        }
    }

    // Check for 404 page
    function check404() {
        const is404 = document.title.toLowerCase().includes('404') || 
                     window.location.pathname.includes('404');
        
        if (is404) {
            trackEvent('404');
        }
    }

    // Initialize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            check404();
            checkOutOfStock();
        });
    } else {
        check404();
        checkOutOfStock();
    }
})();

